import { useState } from "react";
import AdminModal from "../../../core/admin/adminModal";
import { useWatches } from "../../../../context/watchProvider";
import { IWatch } from "../watches/adminWatches";
import AdminCard from "../../../core/admin/adminCard";
import AdminTable from "../../../core/admin/adminTable";
import AdminButton from "../../../core/admin/adminButton";
import AdminEmptyState from "../../../core/admin/adminEmptyState";
import { AdminCount } from "../../../core/admin/adminBadge";
import { PencilIcon } from "../../../../img/svg/adminIcons";

export default function ApprovalWatches({ watches, refresh }: { watches: IWatch[], refresh: () => void }) {

    const { updateWatch } = useWatches();

    const [confirmModal, setConfirmModal] = useState(false);
    const [watch, setWatch] = useState<IWatch | null>(null);
    const [moving, setMoving] = useState(false);

    const doMoveWatch = async (watch: IWatch | null) => {
        if (!watch?.id) {
            return null;
        }
        setMoving(true);
        const response = await updateWatch(watch.id, { status: "draft" });
        setMoving(false);
        if (response) {
            refresh();
        }
    }

    const openConfirmModal = (w: IWatch) => {
        setWatch(w);
        setConfirmModal(true);
    }

    return (
        <AdminCard title={<>Aguardando aprovação <AdminCount count={watches.length} tone={watches.length ? "gold" : "neutral"} /></>} description="Relógios enviados para análise da equipe." bodyClassName="p-3 md:p-4">
            {
                watches.length ?
                    <AdminTable
                        rows={watches}
                        rowKey={(w, idx) => w.id || idx}
                        columns={[
                            { header: "Relógio", mobile: "title", desktopHidden: true, render: w => `${w.brand || ""} ${w.model || ""}` },
                            { header: "Marca", mobile: "hidden", render: w => <span className="font-semibold">{w.brand}</span> },
                            { header: "Modelo", mobile: "hidden", render: w => w.model },
                            { header: "Ano", render: w => w.year },
                        ]}
                        actions={w => <AdminButton size="sm" variant="secondary" icon={<PencilIcon width="14px" />} onClick={() => openConfirmModal(w)}>Editar</AdminButton>}
                    />
                    :
                    <AdminEmptyState title="Nenhum relógio listado" />
            }
            {
                confirmModal ?
                    <AdminModal
                        close={() => setConfirmModal(false)}
                        size="sm"
                        title="Mover relógio para os rascunhos?"
                        footer={
                            <>
                                <AdminButton variant="secondary" disabled={moving} onClick={() => setConfirmModal(false)}>Cancelar</AdminButton>
                                <AdminButton loading={moving} onClick={() => doMoveWatch(watch)}>Sim</AdminButton>
                            </>
                        }
                    >
                        <p className="text-sm text-gray-600">Para editar este relógio, ele precisa ser movido para a área de rascunhos. Depois de editar, envie-o para aprovação novamente.</p>
                    </AdminModal>
                    : null
            }
        </AdminCard>
    )
}
